export default __webpack_public_path__ + "static/media/logo.68a3f0eb.png";